export const YearFilter = ({ years, active, onChange, count, testIdPrefix = "club" }) => (
  <div className="mt-8 flex flex-wrap items-center gap-2" data-testid={`${testIdPrefix}-year-filters`}>
    {years.map((y) => (
      <button
        key={y}
        data-testid={`${testIdPrefix}-filter-year-${String(y).toLowerCase()}`}
        onClick={() => onChange(y)}
        className={`rounded-full px-5 py-2 font-heading text-sm font-bold transition-all duration-300 ${
          active === y
            ? "bg-coal text-sand shadow-md"
            : "bg-white text-coal-muted hover:bg-ember hover:text-sand"
        }`}
      >
        {y}
      </button>
    ))}
    {count !== undefined && count !== null && (
      <span
        className="ml-2 font-mono-brand text-xs font-semibold tracking-widest text-coal-muted"
        data-testid={`${testIdPrefix}-gallery-count`}
      >
        {count} {count === 1 ? "moment" : "moments"}
      </span>
    )}
  </div>
);
